/*
 * File: /Users/yuchao/Desktop/za-docter/za-asclepius-patient-h5/src/components/common/slotMention/index.tsx
 * Project: /Users/yuchao/Desktop/za-docter/za-asclepius-patient-h5
 * Created Date: Wednesday May 11th 2022, 12:34:19 am
 * Author: yuchao (cctv130111@outlook.com>)
 * -----
 * Last Modified: Wednesday, 11th May 2022 12:34:52 am
 * Modified By: yuchao (cctv130111@outlook.com>)
 * -----
 * Copyright (c) 2022 Jie Zhong
 * Description: 有时我们需要在多个页面级别的组件上覆盖一些小玩意儿. e.g 多入口需要展示的小广告。
 * Record: 2022-5-19 添加了一个返回健康险小程序的悬浮按钮组件。用于618活动，从互医返回健康险小程序主会场【涉及多个活动入口及支付结果页】
 */
import React, { useCallback, useEffect, useRef, useState } from 'react';
import Icon_618_Enter from 'src/images/activity/health618/icon_618_enter.png';
import { Deserialize } from 'src/utils';
import { AppletMiddleBridgePagePath, Paths_618_Enter, ReferrerEnum } from './constant';
import './index.scss';
import { Serialize } from 'src/utils/serialization';
import session from 'src/utils/session';
import { withRouter } from 'react-router-dom';
// import { Timeout } from "ahooks/lib/useRequest/src/types";
import { useThrottleFn } from 'src/utils/hooks';
type Timeout = ReturnType<typeof setTimeout>;

const PreClassName = 'slot-mention';
/**
 * @description 节流函数控制的时长
 */
const ScrollThrottleTime = 600;

/**
 * @description
 */
function SlotMention(props): JSX.Element {
  const { location } = props;
  const { search, pathname } = location;
  const [show618Enter, setShow618Enter] = useState(false);
  const [isScroll, toggleIsScroll] = useState(false);
  const [referrer, setReferrer] = useState('');
  const scrollClock = useRef<Timeout>();

  /**
   * @description 点击返回主会场
   */
  const handleOn618Enter = () => {
    const params = {
      referrer,
    };
    wx.miniProgram.navigateTo({ url: `${AppletMiddleBridgePagePath}?${Serialize(params)}` });
  };

  /**
   * @description 处理滚动事件
   */
  const handleScroll = useCallback(() => {
    toggleIsScroll(true);
    scrollClock.current && clearTimeout(scrollClock.current);

    // 控制重新展示浮窗的延迟只需比ScrollThrottleTime大
    scrollClock.current = setTimeout(() => {
      toggleIsScroll(false);
    }, ScrollThrottleTime + 200);
  }, []);

  const { run: handleScrollDebounce } = useThrottleFn(handleScroll, { wait: ScrollThrottleTime });

  // 处理健康险618展示主会场入口逻辑
  useEffect(() => {
    setShow618Enter(!!referrer && referrer === ReferrerEnum.health618 && Paths_618_Enter.some((path) => path === pathname));
  });

  // 目前滚动判断和618活动绑定了
  useEffect(() => {
    if (show618Enter) {
      window.addEventListener('scroll', handleScrollDebounce);
    } else {
      window.removeEventListener('scroll', handleScrollDebounce);
    }
  }, [show618Enter]);

  useEffect(() => {
    const { referrer } = Deserialize(search);
    if (referrer) {
      session.setSessionStorage('referrer', referrer);
    }
    setReferrer(session.getSessionStorage('referrer'));
  }, []);

  return <div className={PreClassName}>
    {
      show618Enter &&
      <img className={`${PreClassName}_618_enter ${isScroll ? 'slide-in' : ''}`} src={Icon_618_Enter} onClick={handleOn618Enter}></img>
    }
  </div>;
}

export default withRouter(SlotMention);
